<template>
  <div class="case-container">
    <ModuleTitleView :title="data?.title || ''"></ModuleTitleView>
    <div class="case-content">
      <ul>
        <li v-for="(item, index) in data?.data.data || []" :key="index">
          <div
              :class="{
                'case-content-item-1 case-content-item': item.content.length === 1,
                'case-content-item-2 case-content-item': item.content.length === 2,
                'case-content-item-3 case-content-item': item.content.length > 2 || item.content.length === 0
              }">
            <ul>
              <li v-for="(subItem, index) in item?.content || []" :key="index">
                <div class="case-content-sub-item-title">{{ subItem?.title }}</div>
                <div v-show="subItem?.url" class="case-content-sub-item-img"
                     :style="{backgroundImage: `url(${subItem?.url ?? ''})`, backgroundSize: 'contain', backgroundPosition: 'center', backgroundRepeat: 'no-repeat'}">
                </div>
              </li>
            </ul>
            <div class="case-content-item-title">{{ item?.description || '' }}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import ModuleTitleView from "@/components/actricle/ModuleTitleView.vue"

const props = defineProps({
  jsonData: Object,
})

const data = reactive(props.jsonData)

</script>

<script>
export default {
  name: 'CaseView'
}
</script>

<style scoped lang="less">
.case-container {
  width: 100%;
  margin-top: 50px;
  overflow: hidden;

  .case-content {
    width: 100%;

    ul {
      width: 100%;
      list-style: none;
      padding: 0;

      li {
        width: 100%;
        list-style: none;
        margin-top: 30px;

        .case-content-item {
          width: 100%;

          .case-content-item-title {
            font-size: 16px;
            color: var(--main-color);
            text-align: center;
            margin-top: 30px;
            font-weight: bold;
            letter-spacing: 1px;
          }
        }

        .case-content-item-1 {
          width: 100%;

          ul {
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            column-gap: 80px; /* 水平方向上的间距 */
            row-gap: 20px; /* 垂直方向上的间距 */
            justify-content: center; /* 居中显示内容 */
            list-style: none; /* 去掉默认的列表样式 */
            padding: 0 223px; /* 去掉默认的内边距 */
            box-sizing: border-box;

            li {
              list-style: none;
              display: flex;
              flex-direction: column; /* 垂直排列 */
              justify-content: center;
              align-items: center; /* 水平居中 */

              .case-content-sub-item-title {
                font-size: 14px;
                color: var(--font-color);
                text-align: center; /* 使文本居中 */
              }

              .case-content-sub-item-img {
                margin-top: 8px;
                width: 100%;
                height: 280px;
              }
            }
          }
        }

        .case-content-item-2 {
          width: 100%;

          ul {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            column-gap: 80px; /* 水平方向上的间距 */
            row-gap: 20px; /* 垂直方向上的间距 */
            justify-content: center; /* 居中显示内容 */
            list-style: none; /* 去掉默认的列表样式 */
            padding: 0 223px; /* 去掉默认的内边距 */
            box-sizing: border-box;

            li {
              list-style: none;
              display: flex;
              flex-direction: column; /* 垂直排列 */
              justify-content: center;
              align-items: center; /* 水平居中 */

              .case-content-sub-item-title {
                font-size: 14px;
                color: var(--font-color);
                text-align: center; /* 使文本居中 */
              }

              .case-content-sub-item-img {
                margin-top: 8px;
                width: 100%;
                height: 280px;
              }
            }
          }
        }

        .case-content-item-3 {
          width: 100%;

          ul {
            display: grid;
            grid-template-columns: repeat(3, 1fr); /* 每行 3 列 */
            column-gap: 80px; /* 水平方向上的间距 */
            row-gap: 20px; /* 垂直方向上的间距 */
            justify-content: center; /* 居中显示内容 */
            list-style: none; /* 去掉默认的列表样式 */
            padding: 0; /* 去掉默认的内边距 */

            li {
              list-style: none;
              display: flex;
              flex-direction: column; /* 垂直排列 */
              justify-content: center;
              align-items: center; /* 水平居中 */

              .case-content-sub-item-title {
                font-size: 12px;
                color: var(--font-color);
                text-align: center; /* 使文本居中 */
              }

              .case-content-sub-item-img {
                width: 100%;
                height: 280px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
